/* src/app/modules/shared/components/column/column-brand/column-brand.component.scss */
app-column-brand {
  display: contents;
}
/*# sourceMappingURL=column-brand.component.css.map */
